import {createSlice} from '@reduxjs/toolkit';
import {
  getTypes,
  editCategory,
  newCategory,
  deleteCategory,
  changeCategoryActive
} from '../../api/PuntosVenta';

export const categoriesPuntoVentaSlice = createSlice({
  name: 'categoriesPuntoVenta',
  initialState: {
    categoriesPuntoVenta: [],
  },
  reducers: {
    setCategories: (state, action) => {
      state.categoriesPuntoVenta = action.payload;
    },
    setActive: (state, action) => {
      const {category, val} = action.payload;
      const index = state.categoriesPuntoVenta.findIndex(el => el.id === category)
      state.categoriesPuntoVenta[index].active = val;
    },
    setCategory: (state, action) => {
      const index = state.categoriesPuntoVenta.findIndex(el => el.id === action.payload.id);
      if (index > -1) {
        state.categoriesPuntoVenta[index] = action.payload;
      }
    },
    addCategory: (state, action) => {
      state.categoriesPuntoVenta.push(action.payload);
    },
    removeCategory: (state, action) => {
      const index = state.categoriesPuntoVenta.findIndex(el => el.id === action.payload);
      if (index > -1) {
        state.categoriesPuntoVenta.splice(index, 1);
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {setCategories, setActive, addCategory, setCategory, removeCategory} = categoriesPuntoVentaSlice.actions;

export const getAllCategories = () => async dispatch => {
  try {
    const response = await getTypes();
    if (!response.error && response.status === 200) {
      dispatch(setCategories(response.data));
      return {
        status: 'success',
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};
/*
export const getTypesList = () => async () => {
  try {
    const response = await getTypes();
    if (!response.error && response.status === 200) {
      return {
        status: 'success',
        types: response.data,
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};
*/
export const activeCategory = (id, val) => async dispatch => {
  try {
    dispatch(setActive({category: id, val: !val}));
    const response = await changeCategoryActive(id);
    console.log("response",response)
    if (!response.error && response.status === 200) {
      return {
        status: 'success',
      };
    }
    dispatch(setActive({category: id, val}));
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    dispatch(setActive({category: id, val}));
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const updateCategory = (id, data) => async dispatch => {
  try {
    const response = await editCategory(id, data);
    if (!response.error && response.status === 200) {
      if (response.data?.status === 300) {
        return {
          status: 'error',
          type: 'incomplete',
        };
      }
      var dataSend = response.data
      dataSend.type = dataSend.name
      dataSend.active = dataSend.visible
      dispatch(setCategory(dataSend));
      return {
        status: 'success',
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const createCategory = data => async dispatch => {
  try {
    const response = await newCategory(data);
    if (!response.error && response.status === 200) {
      if (response.data?.status === 300) {
        return {
          status: 'error',
          type: 'incomplete',
        };
      }
      var dataSend = response.data
      dataSend.type = dataSend.name
      dataSend.active = dataSend.visible
      dispatch(addCategory(dataSend))
      return {
        status: 'success',
        category: response.data,
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const deleteCategoryMonitor = id => async dispatch => {
  try {
    const response = await deleteCategory(id);
    if (!response.error && response.status === 200) {
      dispatch(removeCategory(id));
      return {
        status: 'success',
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const selectCategories = state => state.categoriesPuntoVenta.categoriesPuntoVenta;

export default categoriesPuntoVentaSlice.reducer;
